import { useCallback, useEffect, useState } from 'react';

import { sendOrderNotification } from 'config/requests/orders';
import { OrdersShowResponseBoxStyled } from 'pages/Orders/OrdersShow/components/OrdersShowResponseBox';
import { OrdersShowResponseTitleStyled } from 'pages/Orders/OrdersShow/components/OrdersShowResponseTitle';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useGetOne, useRecordContext } from 'react-admin';
import { useParams } from 'react-router-dom';
import { Button } from 'shared/mui/Buttons';
import { Stack } from 'shared/mui/Stack/Stack';
import { TextField } from 'shared/mui/TextField/TextField';
import { JsonCopyToClipboardField } from 'shared/react-admin/Fields';

import { BoxStyled } from './OrdersShowNotifications.styled';

export const OrdersShowNotificationsCreate: React.FC = () => {
  const { id } = useParams();
  const record = useRecordContext();
  const translate = useTypedTranslate();

  const { data: notificationData = {} } = useGetOne('order_notification_urls', {
    id: record?.orderNotificationUrl?.['@id'] || '',
  });
  const { notificationUrl } = notificationData;

  const [response, setResponse] = useState({});
  const [status, setStatus] = useState<number>();
  const [url, setUrl] = useState(notificationUrl || '');

  useEffect(() => {
    if (notificationUrl) {
      setUrl(notificationUrl);
    }
  }, [notificationUrl]);

  const sendNotification = useCallback(() => {
    sendOrderNotification(id || '')
      .then((response) => {
        setResponse(response.data.data);
        setStatus(response.status);
      })
      .catch((error) => {
        setResponse(error.data);
        setStatus(error.status);
      });
  }, [id]);

  return (
    <Stack gap={2}>
      <BoxStyled>
        <TextField
          disabled
          fullWidth
          label={translate('app.orders.notifications.httpRequest')}
          size="small"
          sx={{ background: '#fff' }}
          value={url}
          variant="outlined"
        />
        <Button
          label={translate('app.orders.notifications.send')}
          onClick={sendNotification}
          sx={{ minWidth: 'initial' }}
          variant="contained"
        />
      </BoxStyled>
      {status && (
        <OrdersShowResponseBoxStyled>
          <OrdersShowResponseTitleStyled fontSize="12px" fontWeight={400}>
            {translate('app.orders.notifications.response')}
          </OrdersShowResponseTitleStyled>
          <JsonCopyToClipboardField
            containerStyle={{
              border: 'none',
            }}
            label={translate('app.orders.notifications.response')}
            src={response}
          />
        </OrdersShowResponseBoxStyled>
      )}
    </Stack>
  );
};
